import { createApi } from '@reduxjs/toolkit/query/react';
import dayjs from 'dayjs';

import { AUCTION_API_URL } from 'api/APIBase';
import { handleError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const auctionApi = createApi({
    baseQuery: getBaseQuery(AUCTION_API_URL),
    reducerPath: 'auctionApi',
    endpoints: (build) => ({
        getLiveReferralDetails: build.query({
            query: ({ referralId, auctionEnd }) =>
                dayjs().isBefore(auctionEnd)
                    ? `admin/${referralId}`
                    : `admin/completed/${referralId}`,
            transformResponse: (response) => ({
                marketplaceParticipants: response?.marketplace_participants,
                defaultRate: response?.default_rate,
            }),
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('An error occurred while fetching Live Referral details.', err);
                }
            },
        }),
    }),
});

export const { useGetLiveReferralDetailsQuery } = auctionApi;
